import * as React from 'react'
import {Helmet} from 'react-helmet'
import styled from 'styled-components'
import {StoreProps} from 'src/stores'
import WarrantForm from 'src/components/organisms/warrant/WarrantForm'

interface Props extends StoreProps {
  location: any
}

export default class WarrantScreen extends React.Component<Props> {
  render() {
    const { location } = this.props
    const metaTitle = 'Benu | Bestattungsvollmacht'
    const metaDesc =
      'Planen und beauftragen Sie eine Bestattung online in vertrauter Umgebung. ✓ Alle Bestattungsarten ✓ In ganz Österreich ✓ Persönliche Beratung ✓ Faire & Transparente Preise ▻ jetzt transparentes Angebot online gestalten!'
    const metaUrl = `https://www.benu.at${location.pathname}`
    const metaImg = 'http://dev.benu.at/benu_logo.png'

    return (
      <div>
        <Helmet>
          <meta charSet='utf-8' />
          <title>{metaTitle}</title>
          <link rel='canonical' href={metaUrl} />

          <meta name='description' content={metaDesc} />
          <meta property='og:title' content={metaTitle} />
          <meta property='og:description' content={metaDesc} />
          <meta property='og:url' content={metaUrl} />
          <meta property='og:type' content='article' />
          <meta property='og:image' content={metaImg} />

          <meta name='author' content='Benu GmbH' />
          <meta name='robots' content='nofollow' />
          <meta name='twitter:card' content={metaImg} />
          <meta name='twitter:site' content='@benu.at' />
          <meta name='twitter:creator' content='@benu.at' />
          <meta name='twitter:title' content={metaTitle} />
          <meta name='twitter:description' content={metaDesc} />
          <meta name='twitter:image' content={metaImg} />
        </Helmet>
        <Container>
          <WarrantForm clever={location.pathname.indexOf('/clever/') < 0 ? false : true}/>
        </Container>
      </div>
    )
  }
}

const Container = styled.form`
  width: 100%;
  max-width: 1200px;
  margin: auto;
  padding: 80px 35px;
`



// WEBPACK FOOTER //
// ./src/screens/warrant/WarrantScreen.tsx